import assert from 'assert'
import axios from 'axios'
import Vue from 'vue'

/**
 * Recebe uma entrada e verifica se a mesma possui valor válido.
 * @param {*} value Variável que será verificada.
 * @returns Boolenao refente a verificação.
 */
export function $mx_hasValue(value) {
	if (value === undefined || value === null || value.length === 0 || value === '') return false
	return true
}



/**
 * Formata e exibe uma mensagem de erro com base na resposta da requisição.
 * @param {Object} response Objeto de resposta da requisição contendo os detalhes do erro.
 * Deve ser passado o objeto response integralmente para garantir a extração correta das mensagens.
 * @returns {void} Dispara o toast e exibe a mensagem formatada.
 */
export function $mx_toastFormatMessages(response) {
	let toastMessage = 'Ocorreu um erro inesperado.'

	if (response?.data) {
			const { msg: message, details } = response.data
			toastMessage = message ?? toastMessage

			if (typeof details === 'string' && !details.trim().startsWith('/')) {
					toastMessage = details
			} else if (details && typeof details === 'object' && Object.keys(details).length > 0) {
					const detailsArray = Object.values(details).flat();
					const formattedDetails = detailsArray.slice(0, 3).join(';<br>') + (detailsArray.length > 3 ? '.<br>...' : '')
					toastMessage = formattedDetails || toastMessage
			}
	}

	Vue.prototype.$toastr.e(toastMessage)
}



/**
 * Mixins com métodos de usos gerais, porém sem contextos limitados.
 * @method $mx_hasValue Verifica se a entrada tem um valor válido.
 * @method $mx_copyObject Retorna uma cópia do objeto.
 * @method $mx_isChanged Verifica duas entrada e retorna se há diferença.
 * @method mx_removeInvalidKeys Retorna apenas as keys sem valor null,false,empty,undefined em um objeto.
 */
export default {
	methods: {
		async $mx_dll(url) {
			const fileName = url.substring(url.lastIndexOf('/') + 1);
			try {
				const response = await axios({
					url,
					method: 'GET',
					responseType: 'blob', // Indica que a resposta deve ser tratada como um Blob
				});

				// Cria um link temporário e atribua o arquivo Blob a ele
				const link = document.createElement('a');
				link.href = window.URL.createObjectURL(new Blob([response.data]));

				// Define o nome do arquivo
				link.download = fileName

				// Adiciona o link ao corpo do documento
				document.body.appendChild(link);

				// Simule um clique no link para iniciar o download
				link.click();

				// Remova o link após o download
				document.body.removeChild(link);
			} catch (error) {
				console.error('Erro ao baixar o arquivo:', error);
			}
		},
		$mx_hasValue,

		/**
		 * Recebe duas strings e verifica se são iguais, ignorando as cases
		 * @param {String} string1 
		 * @param {String} string2 
		 * @returns {Boolean}
		 */
		$mx_isEqual(string1, string2) {
			return (string1 == string2) || (string1.toUpperCase() == string2.toUpperCase()) || (string1.toLowerCase() == string2.toLowerCase())
		},

		/**
		 * Recebe uma string com símbolos, letras, etc a ser excluídos
		 * @param {String} dataToReplace 
		 * @returns {String} Retorna uma string apenas com números
		 */
		$mx_numbersOnly(dataToReplace) {
			return dataToReplace.replace(/\D+/g, '');
		},

		/**
		 * Recebe um data e devolve um data com valores alterados.
		 * @param {Object} object Recebe um objeto
		 * @param {String} string Recebe uma string // o valor a ser substituído
		 * @param {String} string Recebe uma string // o valor substituído
		 * @returns {Object} Retorna um objeto com valores alterados
		 */
		$mx_replaceDataValue(dataToReplace, valueToFind, valueToReplace) {
			const regularExpression = new RegExp(valueToFind, "g");
			const stringData = JSON.stringify(dataToReplace).replace(regularExpression, valueToReplace)

			return JSON.parse(stringData)
		},

		/**
		 * Recebe um objeto e devolve um cópia.
		 * @param {Object} object Recebe um objeto
		 * @returns {Object} Retorna uma cópia do objeto.
		 */
		$mx_copyObject(object) {
			return JSON.parse(JSON.stringify(object))
		},

		/**
		 * Recebe dois objetos e retorna se há uma diferença entre ambos.
		 * @param {Object} newObj Objeto que se espera ser mais recente.
		 * @param {Object} oldObj Objeto antigo que será a base da verificação.
		 * @returns {Boolean} Retorna um booleano referente a verificação.
		 */
		$mx_isChanged(newObj, oldObj) {
			return JSON.stringify(newObj) != JSON.stringify(oldObj)
		},

		/**
		 * Faz uma verificação profunda da diferenteça entre objetos.
		 * Útil quando isChanged não consegue visualizar a diferença.
		 * @param {Object} newObj Objeto que se espera ser mais recente.
		 * @param {Object} oldObj Objeto antigo que será a base da verificação.
		 * @returns {Boolean} Retorna um booleano referente a verificação.
		 */
		$mx_isChangedDeeper(newObj, oldObj) {
			try {
				assert.deepStrictEqual(newObj, oldObj)
				return true
			} catch (err) {
				return false
			}
		},

		/**
		 * Recebe uma string e verifica se o valor é igual a `'active'`.
		 * @param {String} value String que será verificada
		 * @returns {Boolean} Resultado da verificação
		 */
		$mx_checkIsActive(value) {
			return value == 'active'
		},

		/**
		 * Recebe um *booleano* e retorna o termo do contexto referente ao mesmo.
		 * @param {Boolean} value Booleano da verificação.
		 */
		$mx_activeOrInactive(value) {
			return value ? 'active' : 'inactive'
		},

		/**
		 * Recebe uma string e verifica se o valor é igual a `'and'`.
		 * @param {String} value String que será verificada
		 * @returns {Boolean} Resultado da verificação
		 */
		$mx_checkIsAnd(value) {
			return value == 'and'
		},

		/**
		 * Recebe um *booleano* e retorna o termo do contexto referente ao mesmo.
		 * @param {Boolean} value Booleano da verificação.
		 */
		$mx_andOrOr(value) {
			return value ? 'and' : 'or'
		},

		/**
		 * Recebe uma string e verifica se o valor é igual a: `'onlyOwner'`.
		 * @param {String} value String que será verificada
		 * @returns {Boolean} Resultado da verificação
		 */
		$mx_checkIsOnlyOwner(value) {
			return value == 'onlyOwner'
		},

		/**
		 * Recebe um *booleano* e retorna o termo do contexto referente ao mesmo.
		 * @param {Boolean} value Booleano da verificação.
		 */
		$mx_onlyOwnerOrDenied(value) {
			return value ? 'onlyOwner' : 'denied'
		},

		/**
		 * Recebe uma string e verifica se o valor é igual a `'yes'`.
		 * @param {String} value String que será verificada
		 * @returns {Boolean} Resultado da verificação
		 */
		$mx_checkIsYes(value) {
			return value === 'yes'
		},

		/**
		 * Recebe um *booleano* e retorna o termo do contexto referente ao mesmo.
		 * @param {Boolean} value Booleano da verificação.
		 */
		$mx_yesOrNo(value) {
			return value ? 'yes' : 'no'
		},

		/**
		 * Recebe uma string ou number e verifica se o valor é igual a `1`.
		 * @param {String | Number} value Valor que será que será verificado
		 * @returns {Boolean} Resultado da verificação
		 */
		$mx_chekIsOne(value) {
			return parseInt(value) === 1
		},

		/**
		 * Recebe um *booleano* e retorna o termo do contexto referente ao mesmo.
		 * @param {Boolean} value Booleano da verificação.
		 */
		$mx_oneOrZero(value) {
			return value ? '1' : '0'
		},
		
		/**
		 * Remove keys com valores false de acordo com os parametros passados no objeto
		 * @param {Array} value 
		 * @param {Object} params 
		 */
		$mx_removeInvalidKeys(value, params) {
			Object.keys(value).forEach(key => {
				if (value[key] === null || (typeof value[key] === 'object' && value[key] !== null)) {
					Object.keys(value[key]).forEach(innerKey => {
						if (params.removeNulls && value[key][innerKey] === null) {
							delete value[key][innerKey]
						}
						if (params.removeEmptyStrings && value[key][innerKey] === '') {
							delete value[key][innerKey]
						}
						if (params.removeUndefined && value[key][innerKey] === undefined) {
							delete value[key][innerKey]
						}
						if (params.removeFalse && value[key][innerKey] === false) {
							delete value[key][innerKey]
						}
					});
				}
				if (params.removeNulls && value[key] === null) {
					delete value[key];
				}
				if (params.removeEmptyStrings && value[key] === '') {
					delete value[key];
				}
				if (params.removeUndefined && value[key] === undefined) {
					delete value[key];
				}
				if (params.removeFalse && value[key] === false) {
					delete value[key];
				}
			})
		
			return value
		}
		
		// Exemplo de uso
		// let objeto = {
		// 	a: null,
		// 	b: '',
		// 	c: undefined,
		// 	d: false,
		// 	e: {
		// 		f: null,
		// 		g: '',
		// 		h: undefined,
		// 		i: false
		// 	}
		// }
		
		// let parametros = {
		// 	removeNulls: true,
		// 	removeEmptyStrings: true,
		// 	removeUndefined: true,
		// 	removeFalse: true
		// }
		
		// console.log(mx_removeInvalidKeys(objeto, parametros))
	},
}
